var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("viewAssociatedBusiness"),
      !!_vm.upElementBlock
        ? [
            _vm._l(_vm.upElementBlock.elementNames, function(elementName) {
              return _vm._t(elementName)
            })
          ]
        : _vm._e(),
      _vm.middleElementBlocks.length > 0
        ? _c(
            "div",
            {
              staticClass: "section",
              staticStyle: { display: "flex", "flex-direction": "row" }
            },
            [
              _vm._l(_vm.middleElementBlocks, function(item, index) {
                return [
                  item.name === "DangerousGoodsInformation"
                    ? _c(
                        "div",
                        {
                          key: "DangerousGoodsInformation-" + index,
                          staticStyle: { width: "525px" }
                        },
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.title))
                          ]),
                          _c(
                            "el-form",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                                "margin-left": "10px"
                              },
                              attrs: {
                                "label-width": "190px",
                                "label-position": "left"
                              }
                            },
                            [
                              _vm._l(item.elementNames, function(elementName) {
                                return [_vm._t(elementName)]
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          key: "DangerousGoodsInformation2-" + index,
                          staticStyle: { width: "345px", "margin-left": "20px" }
                        },
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.title))
                          ]),
                          _c(
                            "el-form",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                                "margin-left": "10px"
                              },
                              attrs: {
                                "label-width": "120px",
                                "label-position": "left"
                              }
                            },
                            [
                              _vm._l(item.elementNames, function(elementName) {
                                return [_vm._t(elementName)]
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                ]
              })
            ],
            2
          )
        : _vm._e(),
      !!_vm.downElementBlock
        ? [
            _vm._l(_vm.downElementBlock.elementNames, function(elementName) {
              return _vm._t(elementName)
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }